// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Delivery20CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Delivery20CircleFilled: FC<Delivery20CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path
                d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm-5.642-7.142c.405.428.897.642 1.475.642.579 0 1.07-.214 1.476-.642.405-.427.608-.947.608-1.558h4.166c0 .611.203 1.13.608 1.558.405.428.897.642 1.476.642.578 0 1.07-.214 1.475-.642.405-.427.608-.947.608-1.558h1.25v-3.08l-2.083-3.08h-2.084V6.5H5.75c-.344 0-.638.13-.883.388s-.367.569-.367.932v7.48h1.25c0 .611.203 1.13.608 1.558Zm2.07-.931a.785.785 0 0 1-.595.253.785.785 0 0 1-.593-.253A.877.877 0 0 1 7 15.3c0-.25.08-.458.24-.627a.785.785 0 0 1 .593-.253c.236 0 .434.084.594.253.16.169.24.378.24.627 0 .25-.08.458-.24.627Zm8.332 0a.785.785 0 0 1-.593.253.785.785 0 0 1-.594-.253.877.877 0 0 1-.24-.627c0-.25.08-.458.24-.627a.785.785 0 0 1 .594-.253c.236 0 .434.084.593.253.16.169.24.378.24.627 0 .25-.08.458-.24.627Zm1.49-3.267h-2.917v-2.2h1.441l1.476 2.2Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Delivery20CircleFilled;
